import type { LucideIcon } from 'lucide-react'
import {
  Cigarette,
  Coffee,
  Cross,
  DoorClosed,
  Flag,
  Flame,
  Footprints,
  Forklift,
  HeartPulse,
  Info,
  Layers,
  LogIn,
  LogOut,
  MapPin,
  Route,
  ShowerHead,
  Sofa,
  SquareParking,
  Thermometer,
  Trash2,
  Truck,
  Utensils,
  Wrench,
  Zap,
} from 'lucide-react'

import MapViewLocationIcon, {
  type LibraryGlyph,
} from '~/client/src/shared/enums/SitemapAttributeIcon'
import {
  AerialLiftIcon,
  AreaIcon,
  BuildingIcon,
  CraneAltIcon,
  CraneIcon,
  DumpsterIcon,
  ElevatorIcon,
  GateIcon,
  HoistIcon,
  MonitoringIcon,
  MusterPointIcon,
  RestroomIcon,
  StagingIcon,
  StairsIcon,
  TentIcon,
  TrailerIcon,
  WalkwayIcon,
  ZoneIcon,
} from '~/client/src/shared/icons'

export type StandardLocationIcon = Exclude<
  MapViewLocationIcon,
  MapViewLocationIcon.Line | MapViewLocationIcon.TextBox | LibraryGlyph
>

export const LOCATION_GLYPHS: Record<StandardLocationIcon, LucideIcon> = {
  [MapViewLocationIcon.Gate]: GateIcon,
  [MapViewLocationIcon.Zone]: ZoneIcon,
  [MapViewLocationIcon.Building]: BuildingIcon,
  [MapViewLocationIcon.Route]: Route,
  [MapViewLocationIcon.Equipment]: Wrench,
  [MapViewLocationIcon.Level]: Layers,
  [MapViewLocationIcon.Area]: AreaIcon,
  [MapViewLocationIcon.Logistics]: MapPin,
  [MapViewLocationIcon.Bathroom]: RestroomIcon,
  [MapViewLocationIcon.Canteen]: Utensils,
  [MapViewLocationIcon.Break]: Coffee,
  [MapViewLocationIcon.Dumpster]: DumpsterIcon,
  [MapViewLocationIcon.Elevator]: ElevatorIcon,
  [MapViewLocationIcon.Entrance]: LogIn,
  [MapViewLocationIcon.HandWash]: ShowerHead,
  [MapViewLocationIcon.Medical]: Cross,
  [MapViewLocationIcon.MeetingPoint]: MusterPointIcon,
  [MapViewLocationIcon.Parking]: SquareParking,
  [MapViewLocationIcon.Smoking]: Cigarette,
  [MapViewLocationIcon.Stairs]: StairsIcon,
  [MapViewLocationIcon.Shaft]: HoistIcon,
  [MapViewLocationIcon.Temperature]: Thermometer,
  [MapViewLocationIcon.Tent]: TentIcon,
  [MapViewLocationIcon.Toilet]: RestroomIcon,
  [MapViewLocationIcon.Walkway]: WalkwayIcon,
  [MapViewLocationIcon.ElectricalRoom]: Zap,
  [MapViewLocationIcon.Trailer]: TrailerIcon,
  [MapViewLocationIcon.Crane]: CraneIcon,
  [MapViewLocationIcon.Hoist]: HoistIcon,
  [MapViewLocationIcon.AerialLift]: AerialLiftIcon,
  [MapViewLocationIcon.Gradall]: CraneAltIcon,
  [MapViewLocationIcon.ForkLift]: Forklift,
  [MapViewLocationIcon.Monitoring]: MonitoringIcon,
  [MapViewLocationIcon.Staging]: StagingIcon,
  [MapViewLocationIcon.InteriorDoor]: DoorClosed,
  [MapViewLocationIcon.InteriorPath]: Footprints,
  [MapViewLocationIcon.Project]: Flag,
  [MapViewLocationIcon.Truck]: Truck,
  [MapViewLocationIcon.Info]: Info,
  [MapViewLocationIcon.LogOut]: LogOut,
  [MapViewLocationIcon.Trash]: Trash2,
  [MapViewLocationIcon.Sofa]: Sofa,
  [MapViewLocationIcon.HeartPulse]: HeartPulse,
  [MapViewLocationIcon.Flame]: Flame,
}
